import React, { Component } from 'react'
import FixedView from '../FixedView'
import { checkTranslation, timeToTimeAgo, translate } from '../../utils/useful'
import { bindActionCreators } from 'redux'
import * as actions from '../../stores/actionsList';
import { connect } from 'react-redux'
import HttpServices from '../../utils/Http.services';
import CustomLoader from '../CustomLoader';
import Collapsible from 'react-collapsible'
import SocketServices from '../../utils/socket.services';
import { nanoid } from "nanoid";
import NotifConnectionRequestBox from '../boxes/NotifConnectionRequestBox';
import NotifSystemBox from '../boxes/NotifSystemBox';
import NotifInvitationRequestBox from '../boxes/NotifInvitationRequestBox';

class NotificationsMenu extends Component {
    state = {
        collapses: {},
        notifications: [
            // { img: '/images/p4.png', name: 'Ralph Edwards', action: '{{lang}}notif.Wants to edit', target: '{{lang}}notif.Elitive System Design', time: '{{lang}}notif.5 min ago', accept: '{{lang}}notif.Accept', deny: '{{lang}}notif.Deny' },
            // { img: '/images/p1.png', name: 'Ralph Edwards', action: '{{lang}}notif.Wants to edit', target: '{{lang}}notif.Elitive System Design', time: '{{lang}}notif.5 min ago', accept: '{{lang}}notif.Accept', deny: '{{lang}}notif.Deny' },
            // { img: '/images/p2.png', name: 'Ralph Edwards', action: '{{lang}}notif.Wants to edit', target: '{{lang}}notif.Elitive System Design', time: '{{lang}}notif.5 min ago', accept: '{{lang}}notif.Accept', deny: '{{lang}}notif.Deny' },
            // { img: '/images/p3.png', name: 'Ralph Edwards', action: '{{lang}}notif.Wants to edit', target: '{{lang}}notif.Elitive System Design', time: '{{lang}}notif.5 min ago', accept: '{{lang}}notif.Accept', deny: '{{lang}}notif.Deny' },
            // { img: '/images/p4.png', name: 'Ralph Edwards', action: '{{lang}}notif.Wants to edit', target: '{{lang}}notif.Elitive System Design', time: '{{lang}}notif.5 min ago', accept: '{{lang}}notif.Accept', deny: '{{lang}}notif.Deny' },
            // { img: '/images/p5.png', name: 'Ralph Edwards', action: '{{lang}}notif.Wants to edit', target: '{{lang}}notif.Elitive System Design', time: '{{lang}}notif.5 min ago', accept: '{{lang}}notif.Accept', deny: '{{lang}}notif.Deny' },
            // { img: '/images/p6.png', name: 'Ralph Edwards', action: '{{lang}}notif.Wants to edit', target: '{{lang}}notif.Elitive System Design', time: '{{lang}}notif.5 min ago', accept: '{{lang}}notif.Accept', deny: '{{lang}}notif.Deny' },
            // { img: '/images/p7.png', name: 'Ralph Edwards', action: '{{lang}}notif.Wants to edit', target: '{{lang}}notif.Elitive System Design', time: '{{lang}}notif.5 min ago', accept: '{{lang}}notif.Accept', deny: '{{lang}}notif.Deny' },
            // { img: '/images/p8.png', name: 'Ralph Edwards', action: '{{lang}}notif.Wants to edit', target: '{{lang}}notif.Elitive System Design', time: '{{lang}}notif.5 min ago', accept: '{{lang}}notif.Accept', deny: '{{lang}}notif.Deny' },
        ],
        tabs: [
            { key: "all", name: "{{lang}}All Frames", icon: "/assets/icons/applets/database/approval.svg" },
            { key: "reqiests", name: "{{lang}}Requests", icon: "/assets/icons/applets/database/approval.svg" },
            // { key: "assignee", name: "{{lang}}notebook.Assignee", icon: "/assets/icons/applets/database/assignee.svg" },
            // { key: "rooms", name: "Rooms", icon: "/assets/icons/rooms/roomcall.svg" },
        ],
        currentTabs: 'all',
        topicId: nanoid(10),
        data: []
    }
    componentDidMount() {

        setTimeout(() => {
            this.setState({ revealFixed: true })
        }, 10);

        SocketServices.addTopic(this.state.topicId, null, 'notifUpdate', null, this.updateData)

    }

    componentWillUnmount() {
        SocketServices.removeTopic(this.state.topicId, null, 'notifUpdate')

    }




    fetchNotifications = () => {


        // console.log(this.props.hub)

        this.setState({ isLoading: true })
        let hub = (this.props.hub?._id ?? this.props.hub) ?? (this.props.variables?.appletHub?._id ?? this.props.variables?.appletHub)
        let body = { appletHub: hub }

        // console.log(this.props.applet)
        if (this.props.applet?.type == "Settings") {
            body.type = ['request']
        } else {
            if (this.props.applet?._id) {
                body.applet = this.props.applet?._id
            }
        }

        // console.log(body)


        HttpServices.request('getNotifications', body, (fetchResult, fetchError) => {

            // console.log(fetchResult, fetchError)
            this.setState({ isLoading: false })

            if (fetchError) {
                return
            }

            let data = this.state.data
            data = [...data, ...fetchResult.info]

            this.setState({ data, dataIsLoaded: true })
        })
    }


    changeFrame = (item) => {
        this.setState({ currentFrame: item }, () => {

            this.framesView.hideView()

        })
    }


    updateData = (newData, type) => {

        let newDataArray = newData
        if (newData, this.state.dataIsLoaded) {
            let data = this.state.data
            let applet = this.props.applet?._id

            if (!Array.isArray(newData)) {
                newDataArray = [newData]
            } else {
                newDataArray = [...newData]
            }

            newDataArray.forEach(myData => {

                let notifApplet = myData?.applet?._id ?? myData?.applet
                let notifFrame = myData?.frame?._id ?? myData?.frame

                // TO DO: consider frame too

                if (notifApplet == applet) {

                    let found = false
                    data.forEach((oneData, index) => {
                        if (oneData._id == myData._id) {
                            found = true
                            data[index] = oneData
                        }
                    });

                    if (!found) {
                        data.push(myData)
                    }

                    data.sort((a, b) => new Date(b.cDate).getTime() - new Date(a.cDate).getTime())
                    this.setState({ data })
                }

            })
        }

    }

    changeTabs = (prop) => {
        this.setState({ currentTabs: prop.key })
    }


    openView = () => {

        this.notificationView.showView()
        if (this.state.data.length == 0) {
            this.fetchNotifications()
        }
        setTimeout(() => {
            this.setState({ showFixedView: true })
        }, 20);


    }


    showChildren = (parent, data, level) => {
        return (
            <div className={''}>

                {data?.map((item, index) => {
                    if (item.parents &&

                        item.parents[item.parents.length - 1] == parent && !item.hideInDashboard && !item.userperspective)
                        return (
                            <div className={'w-100 position-relative ' + (level > 0 ? ' pld-2' : '')} key={index} >
                                <button onClick={() => { if (item.type != 'folder') { this.changeFrame(item) } else { this.changeCollapse(item._id) } }} className='flexcb w-100 p-2 hover-gray-no-filter br-5  transition-all'>

                                    <div className={"flexcb w-100 "}>
                                        <div className='flexc w-100'>

                                            <div className='flexcc pld-1'>
                                                <img className="transition-all " src={item.icon ?? this.iconSelector(item.type)} height={20} alt='' />
                                            </div>

                                            <div className={'mld-3'}>
                                                <p className='font-size-12 text-semibold main-c3 '>{checkTranslation(item.title ?? item.name)}</p>
                                            </div>
                                        </div>

                                    </div>
                                </button>
                                {/* <div className={'w-100 ' + ((this.state.collapses[item._id] == null ? true : this.state.collapses[item._id]) ? "Collapsible-is-open" : '')}> */}
                                <Collapsible open={this.state.collapses[item._id] == null ? true : this.state.collapses[item._id]}>
                                    {this.showChildren(item._id, data, level + 1)}
                                </Collapsible>
                                {/* </div> */}
                            </div>
                        )
                })}
            </div>
        )
    }



    iconSelector(type) {
        switch (type) {
            case 'collection':
                return '/assets/icons/applets/database.png'
                break;

            case 'messenger':
                return '/assets/icons/portals/chat (2).png'
                break;

            case 'drive':
                return '/assets/icons/applets/drive.png'
                break;

            case 'folder':
                return '/assets/icons/folder (1).png'
                break;

            case 'page':
                return '/assets/icons/applets/notebook.png'
                break;



            default:
                return '/assets/icons/useful/pages.png'
                break;
        }
    }

    notifClicked = (item) => {

        // TO DO: handle different types
        let path = [item.appletHub?.username, item.applet?.slug, 'admin', item.frame?._id]

        if (this.props.changeWindow) {
            this.props.changeWindow(path)
        }
        setTimeout(() => {
            this.notificationView.hideView()
        }, 100);
    }


    renderGeneralNotif = (item) => {

        return (

            <button onClick={() => this.notifClicked(item)} className='bb-gray py-1 position-relative px-2 w-100' style={{ background: item.opened ? '' : '#007aff05' }}>
                <div className='d-flex py-2 w-100'>

                    {!item.opened && (
                        <div className='br-10' style={{ height: 6, width: 6, background: '#007aff', position: 'absolute', top: 15, left: 5 }}></div>
                    )}

                    <div className='w-100'>
                        <div className=' w-100'>
                            <div className='flexc w-100'>
                                <div className='flexc mrd-2'>
                                    <img width={20} height={20} className='' src={'/assets/icons/useful/notification-bell.png'} alt='' />
                                </div>
                                <div className='d-flex flex-column flex-1'>
                                    {item.frame && (
                                        <div className='flexcb'>
                                            <p className='font-size-11 weight-500 ' style={{ color: '#000' }}>{checkTranslation(item.frame?.name)}</p>
                                            <div className='flexc'>
                                                <span className='font-size-11 text-semibold' style={{ color: '#777' }}>{timeToTimeAgo(item.uDate)}</span>
                                            </div>
                                        </div>
                                    )}

                                    <div className='flexcb'>
                                        <div className='text-start'>
                                            <p className={item.frame ? 'font-size-12 weight-500 ' : 'font-size-13 weight-600'}>{checkTranslation(item.title)}</p>
                                            {item.message && (
                                                <p className='font-size-12 weight-400 '>{checkTranslation(item.message)}</p>

                                            )}
                                        </div>
                                        {(item.count && item.count > 1) && (
                                            <div className="br-50 flexcc mld-2" style={{ width: "20px", height: "20px", background: '#007aff' }}  >
                                                <p className="font-size-10 weight-500" style={{ color: "#fff" }} >{item.count}</p>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </button>

        )
    }


    renderNotif = (item) => {

        if (item.type == 'request') {

            return (
                <div className='w-100'>

                    {item.topic == 'invitation' && (
                        <NotifInvitationRequestBox data={item} isPopupMessange={true} addNewWindow={this.props.addNewWindow} />
                    )}
                    {item.topic?.startsWith('connection-') && (
                        // Relation connection requests
                        <NotifConnectionRequestBox data={item} isPopupMessange={true} addNewWindow={this.props.addNewWindow} />
                    )}

                    {/* <NotifConnectionRequestBox data={item} addNewWindow={this.props.addNewWindow} /> */}
                </div>
            )

        } else if (item.type == 'system') {

            return (
                <div className='w-100'>
                    <NotifSystemBox data={item} addNewWindow={this.props.addNewWindow} />
                </div>
            )

        } else {
            return this.renderGeneralNotif(item)
        }

    }


    render() {
        let colors = this.props.colors

        // let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`

        let hub = this.props.hub

        let notifCount

        if ((this.props.applet != null)) {

            if (this.props.applet?.type == 'Settings') {

                notifCount = this.props.inbox?.categorizer?.settings?.count

            } else {

                if (this.props.inbox?.object != null) {
                    notifCount = this.props.inbox?.object[this.props.applet._id]?.count
                }
            }

        } else if (this.props.applet == null && this.state.currentFrame == null && this.props.inbox?.appletHubs != null && this.props.inbox?.appletHubs[hub?._id]?.count > 0) {

            notifCount = this.props.inbox?.appletHubs[hub?._id]?.count

        }

        return (

            <>
                <button className='mld-2 flexcc dark-blur-hover p-1 br-5 flexc position-relative' ref={el => this.notification = el} onClick={() => { this.openView() }} >
                    <img width={24} className={(colors?.iconInvert ? 'invert' : '')} src='/assets/icons/applets/database/notification-white.svg' alt='' />
                    {/* {console.log('firstthis.props.inbox?.object',this.props.inbox?.object)} */}
                    {(notifCount > 0) && (
                        <div className="position-absolute px-1 flexcc px-1" style={{ zIndex: 1, background: '#ee5050', color: '#fff', borderRadius: 20, top: -5, right: -5, height: 18, minWidth: 18 }}>
                            <p className="text-smaller text-semibold">{notifCount}</p>
                        </div>
                    )}

                    {/* {(this.props.applet == null && this.state.currentFrame == null && this.props.inbox?.appletHubs != null && this.props.inbox?.appletHubs[hub?._id]?.count > 0) && (
                        <div className="position-absolute px-1 flexcc px-1" style={{ zIndex: 1, background: '#ee5050', color: '#fff', borderRadius: 20, top: -5, right: -5, height: 18, minWidth: 18 }}>
                            <p className="text-smaller text-semibold">{this.props.inbox?.appletHubs[hub?._id]?.count}</p>
                        </div>
                    )} */}
                </button>
                {this.state.revealFixed && (
                    <FixedView onHide={() => this.setState({ showFixedView: false })} width={260} zIndex={10} ref={el => this.notificationView = el} nodeRef={this.notification} xOffset={219} bottomOffset={0} topOffset={0} maxWidth={260}  >
                        <div className='bg-white br-10 p-1 shadow-3 sc-gray2'>

                            <div className='flexcb pb-0 pt-2 w-100'>
                                <div className='px-2 '>
                                    <p className='text-semibold text-smallest '>{translate("Applet")}</p>
                                    <p className='text-bold text-small '>{translate("Notifications")}</p>
                                </div>

                                <div className='flex-1 flexce w-50'>
                                    <button ref={el => this.framesNode = el} className={"flexc pld-2 prd-4  py-1 mrd-4 br-4 "} onClick={() => this.framesView.showView()} style={{ maxWidth: '100%', backgroundColor: '#f0f0f0', border: '1px solid #eee' }}  >
                                        {this.state.currentFrame ? (
                                            <img className="transition-all mrd-1" src={this.state.currentFrame.icon ?? this.iconSelector(this.state.currentFrame.type)} height={20} alt='' />
                                        ) : (
                                            <img className="transition-all mrd-1 invert" src={'/assets/icons/applets/database/frame-white.svg'} height={20} alt='' />
                                        )}

                                        <p className="font-size-13 text-bold flex-1" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{checkTranslation((this.state.currentFrame ? this.state.currentFrame.name : 'All frames'))}</p>
                                    </button>
                                </div>
                            </div>

                            <div className="w-100 pt-2 px-2 flexcc position-sticky top-0 h-100 w-100" style={{ borderBottom: "1px solid #eee" }}   >

                                <div className="flexc tab-purple-btn2 br-10 w-100">

                                    <button className={"flexc pb-1 mrd-4" + (" selected  ")}    >
                                        <p className="font-size-13 text-bold " style={{ whiteSpace: 'nowrap' }}>{checkTranslation('All')}  </p>
                                        {this.props.applet != null && this.state.currentFrame != null && this.props.inbox.object[this.state.currentFrame.applet]?.frames?.[this.state.currentFrame._id]?.count && (
                                            <div className="br-4 flexcc mld-2 " style={{ minWidth: "18px", height: "18px", background: '#007aff' }}  >
                                                <p className="font-size-11 text-semibold flexcc" style={{ color: "#fff", lineHeight: 1 }} >{this.props.inbox.object[this.state.currentFrame.applet]?.frames?.[this.state.currentFrame._id]?.count}</p>
                                            </div>
                                        )}

                                        {this.props.applet != null && this.state.currentFrame == null && this.props.inbox?.object[this.props.applet?._id]?.count && (
                                            <div className="br-4 flexcc mld-2 " style={{ minWidth: "18px", height: "18px", background: '#007aff' }}  >
                                                <p className="font-size-11 text-semibold flexcc" style={{ color: "#fff", lineHeight: 1 }} >{this.props.inbox?.object[this.props.applet?._id]?.count}</p>
                                            </div>
                                        )}

                                        {this.props.applet == null && this.state.currentFrame == null && this.props.inbox?.appletHubs != null && this.props.inbox?.appletHubs[hub?._id]?.count > 0 && (
                                            <div className="br-4 flexcc mld-2 " style={{ minWidth: "18px", height: "18px", background: '#007aff' }}  >
                                                <p className="font-size-11 text-semibold flexcc" style={{ color: "#fff", lineHeight: 1 }} >{this.props.inbox?.appletHubs[hub?._id]?.count}</p>
                                            </div>
                                        )}


                                    </button>


                                    <button className={"flexc pb-2 mrd-4"} onClick={() => this.changeTabs()}   >
                                        <p className="font-size-13 text-bold" style={{ whiteSpace: 'nowrap' }}>{checkTranslation('Important')}  </p>

                                    </button>

                                </div>
                            </div>

                            {(this.state.isLoading) && (
                                <div className="py-4 flexcc">
                                    <CustomLoader isLoading={true} />
                                </div>
                            )}


                            {this.state.showFixedView && (
                                <FixedView ref={el => this.framesView = el} nodeRef={this.framesNode} topOffset={8} bottomOffset={0} zIndex={10} xOffset={-10} maxWidth={260} width={260} >
                                    <div className="bg-white shadow-3  br-4  p-1 w-100" >
                                        <div className='sc-gray2' style={{ overflow: 'auto', maxHeight: '220px', }}>
                                            <button className='py-2 px-2 w-100 mt-2 flexc hover-gray-no-filter br-5  transition-all' onClick={() => this.changeFrame()}>
                                                <img src='/assets/icons/applets/database/frame-white.svg' height={22} alt='' className=' invert' />
                                                <div className='mld-3'>
                                                    <p className='font-size-13 text-semibold'>{translate("All frames")}</p>
                                                </div>
                                            </button>
                                            {this.props.frames?.map((section, i) => {
                                                if (section
                                                    // && (checkPermission(this.props.permissions, `collection.${section._id}.view`))
                                                    && (section.parents == null || section.parents.length == 0) && !section.userperspective) {

                                                    let hasChildren = false
                                                    let appletId = section.applet?._id ?? section.applet


                                                    return (
                                                        <div key={section._id} className="w-100 " style={{ borderBottom: '0px solid #f6f6f6' }}>
                                                            <button className="flexcb w-100 px-2 py-2 position-relative  hover-gray-no-filter br-5  transition-all " onClick={() => this.changeFrame(section)} >
                                                                <div className="flexc text-start">
                                                                    <img className="transition-all" src={section.icon ?? this.iconSelector(section.type)} width={22} alt='' />
                                                                    <div className='mld-3'>
                                                                        <p className="font-size-12 main-c3 text-bold " style={{}}>{checkTranslation(section.name ?? section.title)}</p>
                                                                    </div>
                                                                </div>
                                                                <div className='flexc'>

                                                                    {this.props.inbox.object[appletId]?.frames?.[section._id]?.count && (
                                                                        <div className="br-30 flexcc" style={{ backgroundColor: '#ee5050', minWidth: '20px', height: '20px', }}>
                                                                            <p className="white font-size-12 text-semibold">{this.props.inbox.object[appletId]?.frames?.[section._id]?.count}</p>
                                                                        </div>
                                                                    )}

                                                                    {hasChildren && (
                                                                        <div className="" onClick={() => this.changeCollapse(section._id)}>
                                                                            <img className={"transition flexcc " + ((this.state.collapses[section._id] == null || this.state.collapses[section._id] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' alt='' />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </button>
                                                            <Collapsible open={this.state.collapses[section._id] == null ? true : this.state.collapses[section._id]}>
                                                                {this.showChildren(section._id, this.props.frames, 1)}
                                                            </Collapsible>
                                                        </div>
                                                    )
                                                }
                                            })}

                                        </div>

                                    </div>
                                </FixedView>
                            )}

                            {this.state.currentTabs == 'all' && (
                                <div className="sc-gray2 w-100" style={{ overflow: "auto", maxHeight: "300px" }}>
                                    {/* {this.props.inbox?.object && this.props.inbox.object[this.props.applet?._id] && this.props.inbox.object[this.props.applet?._id][this.props.page?._id] && this.props.inbox.object[this.props.applet._id][this.props.page._id]?.list?.map((prop, index) => { */}
                                    {this.state.data.map((prop, index) => {
                                        return (
                                            <div className='w-100' key={prop._id}>
                                                {this.renderNotif(prop)}
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                            {/* {this.state.currentTabs == 'approval' && (
                                <div className="sc-gray2 px-2" style={{ overflow: "auto", maxHeight: "300px" }}>
                                    {this.state.notifications.map((prop, index) => {
                                        return (
                                            <div className='bb-gray' key={index}>
                                                <div className='d-flex py-2'>
                                                    <img width={35} height={35} className='br-50 mt-1' src={prop.img} />
                                                    <div className='mld-3'>
                                                        <div className=''>
                                                            <p className='font-size-12 weight-500 main-c4'>{checkTranslation(prop.name)} <span className='font-size-12 weight-300 main-c4'>{checkTranslation(prop.action)}</span> <span className='font-size-12 weight-500 main-c4'>{checkTranslation(prop.target)}</span></p>
                                                            <p className='font-size-12 main-c7'>{checkTranslation(prop.time)}</p>
                                                        </div>
                                                        <div className='flexc mt-2'>
                                                            <button className='px-3 py-1 br-5' style={{ background: background ?? '#007aff' }}>
                                                                <p className='white'>{checkTranslation(prop.accept)}</p>
                                                            </button>
                                                            <button className='gray-btn px-3 py-1 br-5 mld-3'>
                                                                <p>{checkTranslation(prop.deny)}</p>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )} */}
                            {/* {this.state.currentTabs == 'assignee' && (
                                <div className="sc-gray2 px-2" style={{ overflow: "auto", maxHeight: "300px" }}>
                                    {this.state.notifications.map((prop, index) => {
                                        return (
                                            <div className='bb-gray' key={index}>
                                                <div className='d-flex py-2'>
                                                    <img width={35} height={35} className='br-50 mt-1' src={prop.img} />
                                                    <div className='mld-3'>
                                                        <div className=''>
                                                            <p className='font-size-12 weight-500 main-c4'>{checkTranslation(prop.name)} <span className='font-size-12 weight-300 main-c4'>{checkTranslation(prop.action)}</span> <span className='font-size-12 weight-500 main-c4'>{checkTranslation(prop.target)}</span></p>
                                                            <p className='font-size-12 main-c7'>{checkTranslation(prop.time)}</p>
                                                        </div>
                                                        <div className='flexc mt-2'>
                                                            <button className='px-3 py-1 br-5' style={{ background: background ?? '#007aff' }}>
                                                                <p className='white'>{checkTranslation(prop.accept)}</p>
                                                            </button>
                                                            <button className='gray-btn px-3 py-1 br-5 mld-3'>
                                                                <p>{checkTranslation(prop.deny)}</p>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )} */}
                        </div >

                    </FixedView >
                )
                }
            </>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationsMenu);